import React from 'react';
import { Square } from 'react-feather';
import Main from './components/_Main';
import titleGraphic from './img/floskel-lagspelare.svg';
import pageData from '../../data/lagspelare';

const currentPageData = pageData.find(page => page.order === 1);

const Tutorial = () => (
  <div>
    <div className="SectionHeader">
      <span className="SectionHeader__text">
        <h2 className="SectionHeader__title">{currentPageData.heading}</h2>
        <p className="lead">{currentPageData.subheading}</p>
      </span>
      <img alt="" src={titleGraphic} className="SectionHeader__graphic" />
    </div>

    <ul className="DescriptionList">
      <li className="DescriptionList__item">
        <Square className="DescriptionList__graphic" />
        <span className="DescriptionList__text">{currentPageData.dl1}</span>
      </li>
      <li className="DescriptionList__item">
        <Square className="DescriptionList__graphic" />

        <span className="DescriptionList__text">{currentPageData.dl2}</span>
      </li>
    </ul>
  </div>
);

export default () => <Main currentPageNum={1} tutorial={<Tutorial />} hero={false} />;



// WEBPACK FOOTER //
// ./src/pages/lagspelare/index.js